import { render, staticRenderFns } from "./MentorList.vue?vue&type=template&id=2b202780&scoped=true&"
import script from "./MentorList.vue?vue&type=script&lang=js&"
export * from "./MentorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b202780",
  null
  
)

export default component.exports